/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { ConfigConstant } from '@apitable/core';
import { isMobileApp } from './env';

export const isWindowsOS = () => {
  const agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
    return true;
  }
  if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
    return true;
  }
  return false;
};

export const isMac = () => {
  const agent = navigator.userAgent;
  return /macintosh/i.test(agent);
};

export const isWxWork = () => {
  const agent = navigator.userAgent;
  return /wxwork/i.test(agent);
};

export const isDesktop = () => {
  if (process.env.SSR) {
    return;
  }
  return (window as any).bowser.test(/VikaDesktop/);
};

export const getPlatformType = () => {
  if (isDesktop()) {
    return ConfigConstant.PlatFormTypes.Desktop;
  }
  if (isMobileApp()) {
    return ConfigConstant.PlatFormTypes.App;
  }

  return ConfigConstant.PlatFormTypes.Web;
};

export const browserIsDesktop = async() => {
  if (process.env.SSR) {
    return false;
  }
  const device = await import('current-device');
  return device.default.desktop();
};

